import React from 'react';
import classnames from 'classnames';

// Recursively applies configured class names to nested spans.
export const AppliedClassNames: React.FC<{
  value: React.ReactNode;
  classNames: string[][];
}> = ({ value, classNames }) => {
  if (classNames.length == 0) {
    return <span>{value}</span>;
  }

  const innerSpan = (index: number) => {
    if (index == classNames.length - 1) {
      return <span className={classnames(classNames[index])}>{value}</span>;
    }

    return (
      <span className={classnames(classNames[index])}>
        {' '}
        {innerSpan(index + 1)}
      </span>
    );
  };

  return innerSpan(0);
};
